import { render, staticRenderFns } from "./Pin.vue?vue&type=template&id=3f6946c4&scoped=true"
import script from "./Pin.vue?vue&type=script&lang=js"
export * from "./Pin.vue?vue&type=script&lang=js"
import style0 from "./Pin.vue?vue&type=style&index=0&id=3f6946c4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6946c4",
  null
  
)

export default component.exports